import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Empty, Modal, Tabs, Pagination} from 'antd';
import BaseComponent from "../../../../base/BaseComponent";
import TableList from './compontent/TableList'
import company from "./img/company.png";
import StorageSpace from "./compontent/Storagespace";
import ResourceData from './compontent/ResourceData'
import SearchModule from './compontent/SearchModule'
import {Scrollbars} from "react-custom-scrollbars";
import './css/index.css'
import $ from "jquery";
import File from "./compontent/File";
import Detailpage from "../../components/DetailPage";
import {uuid} from "../../../../utils";
import {message} from "../../components/Mess";

const {TabPane} = Tabs;

export default class resourceIndex extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            tabList: [{name: '全部', type: 'all',},
                {name: '图片', type: 'picture',},
                {name: '视频', type: 'video'},
                {name: '音频', type: 'audio'},
                {name: '其他', type: 'other_file'},

            ],
            current: 'all',
            param: {
                pageNum: 1,
                pageSize: 24,
            },
            data: {},
            dataSource: [],
            count: 0,
            key: '',
            searchList: [],
            originFileObj: '',//本地上传 还是资源库选择
            queryKey: '',
            type: '', 

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.setState({}, () => {
            $('.antContent').css('margin-left', '0');
            $('.antContent').css('margin-right', '0')
        })
    }

    render() {
        let left;
        let list = this.state.searchList;
        let clientWidth = document.body.clientWidth;
        if (clientWidth >= 1800) {
            left = 140
        } else if (clientWidth < 1800) {
            left = 40
        }
        let text = this.sysConfigGetValueByKey('zyk_IndexText', '')
        let resourceBackgroundImg = this.sysConfigGetValueByKey('zyk_backgroundImg', '')  || company;
        let width = document.body.clientWidth - 2 * left;
        let height;
        if (document.body.clientHeight < 900) {
            height = 1300 + 1000
        } else {
            height = document.body.clientHeight + 1000
        }
        return (
            <Scrollbars autoHeight autoHide
                        autoHeightMax={1457}
            >
                <div style={{
                    left: 0,
                    width: "100%",
                    height: height,
                    marginTop: '6px',
                }}>
                    <div style={{
                        backgroundImage: `url(${resourceBackgroundImg})`,
                        width: "100%",
                        height: 800,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: "cover",
                        backgroundPosition: "top center",
                    }}>
                        <div style={{paddingTop: '104px'}} className={'copywriting'}>
                            <SearchModule
                                key={this.state.queryKey}
                                type={'index'}
                                ref={ref => this.searchModule1 = ref}
                                localUpload={(info, data) => {
                                    this.zykTable();
                                    this.localUploadInit(info, data, 'index');
                                    this.isHideLoading(info, data, 'index')
                                }}

                                insertPictureToContent={(data, param) => {
                                    this.zykTable();
                                    this.state.param.pageNum = 1;
                                    this.state.param.pageSize = 24;
                                    this.state.searchList = data;
                                    this.state.visible = true;
                                    this.state.current = 'all';
                                    this.state.data = param;
                                    this.state.dataSource = [];
                                    this.state.count = 0;
                                    this.state.type = 'zyk';
                                    this.setState({}, () => {
                                        setTimeout(() => {
                                            this.searchModule2 && this.searchModule2.setData(param)
                                        }, 0);
                                        this.getInsertPictureList()
                                    })
                                }}
                                showModule={(data) => {
                                    this.initTable();
                                    this.initTable();
                                    this.showModule(data)
                                }}
                            />
                        </div>
                        <div style={{
                            fontSize: "54px",
                            color: "#ffffff",
                            marginTop: " 200px",
                            textAlign: "center",
                            lineHeight: "81px",
                            height: "81px"
                        }}>{text ? text: ""}</div>
                        <div style={{
                            width: "84px",
                            height: "4px",
                            margin: '32px auto',
                            background: text ? "#fff" : ""
                        }}></div>
                        <div style={{marginLeft: left, width: width}}>
                            <div style={{margin: '226px auto 40px auto'}}>
                                <TableList></TableList>
                            </div>
                            <div style={{display: 'flex', marginTop: '40px'}}>
                                <ResourceData></ResourceData>
                                <StorageSpace></StorageSpace>
                            </div>
                        </div>
                    </div>
                    <Modal
                        visible={this.state.visible}
                        width={1200}
                        key={this.state.key}
                        footer={null}
                        keyboard
                        maskClosable={false}
                        onCancel={() => {
                            this.setState({visible: false, key: uuid(), searchList: [], queryKey: uuid()}, () => {
                                setTimeout(() => {
                                    this.state.data.keyword = '';
                                    this.setState({}, () => {
                                        this.searchModule1 && this.searchModule1.setData(this.state.data)
                                    })
                                }, 0)
                            })
                        }}
                        bodyStyle={{height: '683px'}}
                    >
                        <div>
                            <SearchModule
                                type={'search'}
                                key={this.state.queryKey}
                                localUpload={(info, data) => {
                                    this.zykTable();
                                    this.state.data.keyword = '';
                                    this.setState({}, () => {
                                        this.searchModule1 && this.searchModule1.setData(this.state.data)
                                    })
                                    this.localUploadInit(info, data, 'index', () => {
                                        this.isHideLoading(info, data, 'index')
                                    });
                                }}
                                insertPictureToContent={(data, param) => {
                                    this.zykTable();
                                    this.state.data.keyword = '';
                                    this.state.param.pageNum = 1;
                                    this.state.param.pageSize = 24;
                                    this.state.searchList= data;
                                    this.state.dataSource= [];
                                    this.state.count= 0;
                                    this.state.data= param;
                                    this.state.type='zyk';
                                    this.state.current= 'all';
                                    this.setState({}, () => {
                                        this.searchModule1 && this.searchModule1.setData(this.state.data)
                                        this.getInsertPictureList()
                                    });
                                }}
                                ref={ref => this.searchModule2 = ref}
                                selectCallBack={(data) => {
                                    this.initTable();
                                    this.state.param.pageNum = 1;
                                    this.state.param.pageSize = 24;
                                    this.state.type = '';
                                    this.state.data = data;
                                    this.state.searchList = [];
                                    this.setState({},
                                        () => {
                                            this.getDataSource()
                                        })
                                }}
                            />
                            {list && list.length ? list.map((item, index) => {
                                return (
                                    <div key={index}><img
                                        style={{width: '88px', height: '88px', marginTop: '20px', objectFit: 'contain'}}
                                        src={item.icon || item.path} key={item.id}/>
                                    </div>)

                            }) : null}
                            {this.renderTab()}
                            {this.renderData()}
                        </div>
                    </Modal>
                </div>
            </Scrollbars>
        )
    }

    //渲染tab
    renderTab() {
        let {tabList} = this.state;
        return (

            <Tabs style={{marginTop: '10px'}} activeKey={this.state.current} onChange={(value) => {
                tabList.forEach((item) => {
                    if (item.type === value) {
                        this.state.current = item.type
                    }
                });
                this.state.param.pageNum = 1;
                this.state.param.pageSize = 24;
                this.state.dataSource = [];
                this.setState({}, () => {
                    if (this.state.type === 'index') {
                        this.getSearchList()
                    } else if (this.state.type === 'zyk') {
                        this.getInsertPictureList()
                    } else {
                        this.getDataSource()
                    }
                })
            }}>
                {this.state.tabList && this.state.tabList.length && this.state.tabList.map((item, index) => {
                    return (
                        <TabPane tab={item.name} key={item.type}></TabPane>
                    )
                })}
            </Tabs>
        )
    }

    initTable = () => {
        let tabList = [{name: '全部', type: 'all',},
            {name: '图片', type: 'picture',},
            {name: '视频', type: 'video'},
            {name: '音频', type: 'audio'},
            {name: '其他', type: 'other_file'},

        ];
        this.setState({tabList: tabList})
    };
    zykTable = () => {
        let tabList = [{name: '全部', type: 'all',},
            {name: '图片', type: 'picture',},
        ];
        this.setState({tabList: tabList})
    };

    //  渲染数据
    renderData() {
        let {dataSource} = this.state;
        return (
            <div><Scrollbars autoHide autoHeightMax={this.state.searchList && this.state.searchList.length ? 350 : 480}
                             autoHeight style={{marginTop: '20px',}}
            >
                {
                    dataSource && dataSource.length > 0 ? <div style={{
                        display: 'grid',
                        justifyContent: 'space-between',
                        padding: '0px 40px 0px 0px',
                        columnGap: '30px',
                        rowGap: '30px',
                        gridTemplateColumns: ' repeat(auto-fill,104px)',
                    }}>{dataSource.map((item, index) => {
                        return <File file={item}
                                     key={item.id}
                                     width={item.width}
                                     height={item.height}
                                     onClick={() => {
                                         this.itemClick(item, index)
                                     }}
                                     download={() => {
                                         this.downLoad(item)
                                     }}>
                        </File>
                    })}
                    </div> : <Empty style={{margin: "100px auto"}}/>

                }
            </Scrollbars>
                <div style={{
                    display: 'flex',
                    justifyContent: 'right',
                    height: '64px',
                    lineHeight: '64px',
                    marginTop: '10px',
                    flexDirection: 'row-reverse',
                    borderTop: '1px solid #e8e8e8',
                    alignItems: "center"
                }}>
                    <Pagination current={this.state.param.pageNum}
                                showQuickJumper
                                hideOnSinglePage
                                pageSize={this.state.param.pageSize}
                                total={this.state.count}
                                showTotal={total => `共 ${total} 条`}
                                onChange={(page, pageSize) => {
                                    this.onChangePage(page, pageSize)
                                }}
                                onShowSizeChange={(page, pageSize) => {
                                    this.onChangePage(page, pageSize)
                                }}/>
                </div>
                <Detailpage key={this.state.modalKey}
                            onRef={ref => this.setDetailpage = ref}
                            onCloseCall={() => {
                                this.setState({modalKey: uuid()})
                            }}
                            dataList={this.state.dataSource}>
                </Detailpage>
            </div>

        )
    }

    onChangePage(page, size) {
        this.state.param.pageNum = page;
        this.state.param.pageSize = size;
        this.setState({}, () => {
            if(this.state.searchList&&this.state.searchList.length){
                if (this.state.type === 'index') {
                    this.getSearchList()
                } else if (this.state.type === 'zyk') {
                    this.getInsertPictureList()
                } else {
                    this.getDataSource()
                }
            }else{
                this.getDataSource()
            }

        })
    }

    //获取弹框列表
    getDataSource(data) {
        let authType = this.state.data.key;
        let indexName = this.state.current;
        const {param} = this.state;
        if (this.state.data.keyword) {
            param.keyword = this.state.data.keyword
        } else {
            delete param.keyword
        }
        if (data) {
            param.ids = data
        } else {
            delete param.ids
        }
        this.request({
            url: `/search-server/search/getList/${indexName}/${authType}`,
            method: "POST",
            body: param,
            loading: true,
            contentType: 'json',
            callBack: (res) => {
                let array = [];
                if (res) {
                    this.state.count = res.count;
                    if (res && res.data && res.data.length) {
                        array = res.data;
                    }
                }
                this.setState({dataSource: array});
            },
            errorCallBack: (e) => {
                this.setState({dataSource: []});
            },
            serverVerify: {
                serverErrorCallBack: (e) => {
                    console.log(e)
                }
            }
        });
    }

    //本地上传时间
    localUploadInit = (info, data, status, call) => {
        this.state.data = data;
        this.state.current = 'all';
        this.state.dataSource = [];
        this.state.count = 0;
        this.state.type = status;
        this.state.param.pageNum = 1;
        this.state.param.pageSize = 24;
        if (status === 'index') {
            this.state.visible = true;
            setTimeout(() => {
                this.searchModule2 && this.searchModule2.setData(data)
            }, 0)
        }
        this.setState({}, () => {
            window.loading.show();
            call && call()
        })

    };
    //时候隐藏loading
    isHideLoading = (info, data, status) => {
        if (info.file.status === 'done') {
            if (info.file.response && info.file.response.data) {
                info.file.response = {...info.file.response.data, ...info.file.response};
            }
            let newData = info.file.response;
            let originFileObj = info.file.originFileObj;
            this.setState({searchList: [newData], originFileObj: originFileObj}, () => {
                window.loading.hide();
                this.getSearchList()
            })

        }
    };

    //首页点击搜索事件 打开弹窗
    showModule = (data) => {
        this.state.searchList = [];
        this.state.current = 'all';
        this.state.visible = true;
        this.state.data = data;
        this.state.param.pageNum = 1;
        this.state.param.pageSize = 24;
        this.state.type = '';
        this.setState({}, () => {
            this.getDataSource();
            setTimeout(() => {
                this.searchModule2 && this.searchModule2.setData(data)
            }, 0)
        })
    };

    //详情页
    itemClick(item, index) {
        let status = item.extendedAttributeJson && item.extendedAttributeJson.download ? item.extendedAttributeJson.download : false;
        if (!status) {
            this.setDetailpage.show(true, item, index)
        } else {
            message.error("您没有所选资源的使用权限，请申请下载！")
        }

    }

    //本地上传
    getSearchList() {
        let formData = new FormData();
        formData.append('image', this.state.originFileObj);
        this.request({
            url: '/cm-sites-storage-management/face/search',
            method: 'post',
            body: formData,
            contentType: 'upload',
            callBack: async (data) => {
                if (data && data.data) {
                    this.state.uploadList = data.data;
                    this.setState({}, () => {
                        this.getDataSource(data.data)
                    })

                }
            }
        });
    }

    //资源库选择
    getInsertPictureList() {
        let parms = {
            "fileName": this.state.searchList && this.state.searchList.length && this.state.searchList[0].name,
            "virtualFileId": this.state.searchList && this.state.searchList.length && this.state.searchList[0].id
        };
        this.request({
            url: '/cm-sites-storage-management/face/zykSearch',
            method: 'post',
            body: parms,
            contentType: 'json',
            callBack: (data) => {
                if (data && data.data) {
                    this.getDataSource(data.data)
                }
            }
        });
    }

    //下载
    downLoad = (record) => {
        this.request({
            url: "/cm-sites-storage-management/zykDownLoad/addZykDownLoad",
            method: "post",
            body: {virtualFileId: record.id, name: record.name, downloadFlag: false},
            contentType: 'json',
            callBack: (data) => {
                if (data) {
                    let url = "/storage/downloadFile?md5=" + record.md5 + '&download=1';
                    let aObj = document.createElement('a');
                    aObj.setAttribute('download', '');
                    aObj.setAttribute('href', url);
                    aObj.click();
                    aObj = null
                }
            }
        });
    }
}
